"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _helpers = require("../helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*
 * Use gutter taken directly from the theme passed as a prop - this way we can get different size grid-gutters by just wrapping the component in a new ThemeProvider
 */

var Column = _styledComponents["default"].div.withConfig({
  displayName: "Grid__Column",
  componentId: "sc-1vvhqwl-0"
})(["flex-basis:auto;width:100%;min-width:0;", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";"], function (props) {
  return props.width && (0, _styledComponents.css)(["width:", ";"], props.width === "auto" ? "auto" : "calc(100% * ".concat(props.width, ")"));
}, function (props) {
  return props.grow && (0, _styledComponents.css)(["width:auto;flex-grow:", ";"], typeof props.grow !== "boolean" ? props.grow : 1);
}, function (props) {
  return props.shrink && (0, _styledComponents.css)(["width:auto;flex-shrink:", ";"], typeof props.shrink !== "boolean" ? props.shrink : 1);
}, function (props) {
  return props.textAlign && (0, _styledComponents.css)(["text-align:", ";"], props.textAlign);
}, function (props) {
  return props.borderLeft && (0, _styledComponents.css)(["border-left:1px solid ", ";"], props.theme.colors.border);
}, function (props) {
  return props.borderBottom && (0, _styledComponents.css)(["border-bottom:1px solid ", ";"], props.theme.colors.border);
}, function (props) {
  return props.alignSelf && (0, _styledComponents.css)(["align-self:", ";"], props.alignSelf);
}, function (props) {
  return props.direction && (0, _styledComponents.css)(["flex-direction:", ";"], props.direction);
}, function (props) {
  return props.justifyContent && (0, _styledComponents.css)(["justify-content:", ";"], props.justifyContent);
}, function (props) {
  return props.alignItems && (0, _styledComponents.css)(["align-items:", ";"], props.alignItems);
});
var Grid = _styledComponents["default"].div.withConfig({
  displayName: "Grid",
  componentId: "sc-1vvhqwl-1"
})(["display:flex;flex-flow:row wrap;width:calc( 100% + ", " );margin-left:-", ";margin-top:0;margin-right:0;margin-bottom:0;padding:0;list-style:none;& > ", "{padding-left:", ";}", ";", ";", ";", ";", ";", ";", ";"], function (props) {
  return (0, _helpers.getSpace)(props, "gutter");
}, function (props) {
  return (0, _helpers.getSpace)(props, "gutter");
}, Column, function (props) {
  return (0, _helpers.getSpace)(props, "gutter");
}, function (props) {
  return (props.equalHeights || props.flexColumns) && (0, _styledComponents.css)(["", "{display:flex;}"], Column);
}, function (props) {
  return props.autoWidths && (0, _styledComponents.css)(["", "{width:auto;flex-grow:1;}"], Column);
}, function (props) {
  return props.middle && (0, _styledComponents.css)(["align-items:center;"]);
}, function (props) {
  return props.bottom && (0, _styledComponents.css)(["align-items:flex-end;"]);
}, function (props) {
  return props.center && (0, _styledComponents.css)(["justify-content:center;"]);
}, function (props) {
  return props.right && (0, _styledComponents.css)(["justify-content:flex-end;"]);
}, function (props) {
  return props.gutterV && (0, _styledComponents.css)(["margin-top:-", ";& > ", "{margin-top:", ";}"], (0, _helpers.getSpace)(props, "gutterV", props.gutter), Column, (0, _helpers.getSpace)(props, "gutterV", props.gutter));
});
Grid.Column = Column;
var _default = Grid;
exports["default"] = _default;